import classNames from 'classnames';
import React, { FC } from 'react';
import styles from "./Toggle.module.scss";

interface ToggleProps{
    leftValue?: string;
    rightValue?: string;
    className?: string;
    checked: boolean;
    setChecked: (newVal: boolean)=>void;
    dimUnchecked? : boolean;
    valueClass?: string; 
    design?: "switcher" | "toggle";
}

const Toggle : FC<ToggleProps> = ({
    leftValue, 
    rightValue, 
    className, 
    checked, 
    setChecked, 
    dimUnchecked,
    valueClass,
    design = "toggle",
}) => {

    const random : number = Math.random()*1000;

    return(
        <div className={classNames(
            styles.toggle, 
            design && styles[`toggle__${design}`],
            className && className
        )} key={"toggle-"+random}>
            <label className={styles.switch}>
                    {leftValue?<span className={classNames(styles.slider_left_val, (dimUnchecked && checked && styles.slider_dim), valueClass && valueClass)}>{leftValue}</span>:null}
                    <span className={styles.slider_out}>
                        <input checked={checked} onChange={()=>setChecked(!checked)} type="checkbox" />
                        <span className={styles.slider}></span>
                    </span>
                    {rightValue?<span className={classNames(styles.slider_right_val, (dimUnchecked && !checked && styles.slider_dim), valueClass && valueClass)}>{rightValue}</span>:null}
            </label>
        </div>
    );
}
export default Toggle;